module.exports = __webpack_public_path__ + "static/media/google_play_store_badge.e4cb19ea.svg";